import * as LJS from '../lib/littlejs.esm.js';
import Globals from './globals.ts';
import { getCenterTextPos } from './utils/font.ts';
const HUD_PADDING = 32;
const HUD_FONTSIZE = 32;
// Colors
const TEXT_COLOR = LJS.hsl(0, 1, 1);
const LINE_COLOR = LJS.hsl(0, 0, 0, 0);
export default class GameOver {
    static render() {
        const canvWidth = LJS.mainCanvasSize.x;
        const canvHeight = LJS.mainCanvasSize.y;
        const font = new LJS.FontImage;
        LJS.drawRect(LJS.vec2(0, 0), LJS.mainCanvasSize, Globals.BLACK);
        const gameOverX = getCenterTextPos('GAME OVER', 4);
        font.drawTextScreen('GAME OVER', LJS.vec2(gameOverX, canvHeight / 2 - HUD_FONTSIZE * 4), 4);
        const scoreText = `SCORE : ${Globals.score} M`;
        const scoreX = getCenterTextPos(scoreText, 2);
        font.drawTextScreen(scoreText, LJS.vec2(scoreX, canvHeight / 2), 2);
        font.drawTextScreen(` BEST : ${Globals.bestScore} M`, LJS.vec2(scoreX, canvHeight / 2 + HUD_FONTSIZE), 2);
        if (Globals.score == Globals.bestScore) {
            const bestX = getCenterTextPos('NEW BEST !', 1);
            font.drawTextScreen('NEW BEST !', LJS.vec2(bestX, canvHeight / 2 + HUD_FONTSIZE * 2), 1);
        }
        const startText = 'Press SPACE to retry';
        const startX = getCenterTextPos(startText, 2);
        font.drawTextScreen(startText, LJS.vec2(startX, canvHeight - 108), 2);
    }
}
